<template>
  <div class="home">
    <adddeviceType v-if="isAdd" @cancelModel="cancelM"></adddeviceType>
    <v-header :go-back="false" :if-login="islogin" :mine='true' @addDevice='isShowModel'></v-header>
    <div class="title" ref="title">{{$t('device.myDevice')}}</div>
    <div v-if="islogin">
      <div class="device_main" ref="wrapper">
        <div ref="deviceBox">
          <div v-if="infos!=0">
            <div v-show="addDeviceBtn" class="addDeviceBtn">
              <span>{{$t('device.deviceNull')}}</span>
              <!-- <router-link to="/addDevice" class="addBtn">{{$t('device.addNewDevice')}}</router-link> -->
            </div>
            <div class="device_content">
              <div class="device_title">
                <div class="device_code">{{$t('device.deviceCode')}}</div>
                <div class="bind_pet">{{$t('device.bindPet')}}</div>
              </div>
              <v-slider :infos="infos" v-on:listen-is-show="getShowMsg"></v-slider>
            </div>
          </div>
          <div class="hint" v-else>{{$t('device.nobindDevice')}}</div>
        </div>
      </div>
    </div>
    <div class="notlogin" v-else>
      {{$t('device.noLogin')}}
      <router-link :to="{name:'login'}">{{$t('device.goLogin')}}</router-link>
    </div>
    <v-choosePet
      ref="banner"
      @react="react"
      :deviceCode="deviceCode"
      :addBtn="true"
      :isShow="isShow"
      v-on:listen-isShow="listenIsShow"
    ></v-choosePet>
    <v-foot :loginsuccess="loginsuccess" :loginshowflag="loginshowflag"></v-foot>
  </div>
</template>
<script >
import { getDevices } from "../../deviceApi/index.js";
import header from "../../components/header";
import store from "../../store/store.js";
import footernav from "../../components/footernav";
import slider from "../../components/slider";
import IScroll from "iscroll/build/iscroll-probe";
import choosePet from "../../components/choosePet";
import adddeviceType from "../home/adddeviceType";
import { getLoginUser } from "../../api/index.js";
export default {
  name: "home",
  data() {
    return {
      islogin: false,
      isShow: false, //判断choosePet面板打开关闭的值
      infos: "",
      loginsuccess: false,
      loginshowflag: true,
      getToken: sessionStorage["token"],
      imei: "",
      addDeviceBtn: false,
      deviceCode: "", //获得点击的设备devicedCode
      isAdd: false
     
    };
  },
  mounted() {
    
    if (this.islogin == true) {
      this.$nextTick(() => {
        this.Scroll = new IScroll(this.$refs.wrapper, {
          click: true
        });
      });
      this.$refs.wrapper.style.top = this.$refs.title.offsetHeight + 40 + "px";
      this.$refs.wrapper.style.height =
        window.innerHeight - this.$refs.title.offsetHeight - 80 + "px";
      this.$refs.deviceBox.style.height =
        window.innerHeight - this.$refs.title.offsetHeight + "px";
    }
  },
  created() {
    //查询本地是否有token，有则自动登录，若没有则检查session是否
    if (localStorage.token) {
      this.$store.commit("set_token", localStorage.token);
      sessionStorage.login = 1;
    }
    var geolocation = new BMap.Geolocation();
    geolocation.getCurrentPosition(
      function(r) {
        if (this.getStatus() == BMAP_STATUS_SUCCESS) {
          // console.log(r.point);
          sessionStorage.setItem("lng", r.point.lng);
          sessionStorage.setItem("lat", r.point.lat);
        } else {
          alert("failed" + this.getStatus());
        }
      },
      {
        enableHighAccuracy: true
      }
    );
    // console.log(this.$route.query.x_auth_token)
    if (this.$route.query.x_auth_token) {
      this.$store.commit("set_token", this.$route.query.x_auth_token);
      sessionStorage.setItem("login", "1");
      sessionStorage.setItem("third", "1");
    }
    //检验是否登陆超时
    if (sessionStorage.getItem("login") == 1) {
      getLoginUser()
        .then(res => {
          if (res.data.header.status == 3023) {
            sessionStorage.setItem("login", "1");
            this.$message({
              type: "success",
              message: this.$t("prompt.header")
            });
            this.$router.push("/login");
          }
        })
        .catch(err => {});
    }
    if (sessionStorage.login == 1) {
      this.islogin = sessionStorage.login;
      getDevices()
        .then(res => {
           console.log('add dev:',res);
          if (res.data.header.status == 1000) {
            this.infos = res.data.data;
            if (this.infos.length == "0") {
              this.addDeviceBtn = true;
            } else {
              this.addDeviceBtn = false;
            }
          }
          if (res.data.header.status == 80042) {
            this.$message({
              type: "success",
              message: this.$t("prompt.header")
            });
            this.$router.push("/login");
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
    if (sessionStorage.getItem("login")) {
      this.loginsuccess = true;
      this.loginshowflag = false;
    }else{
      this.loginsuccess = false;
      this.loginshowflag = true;
    }
  },
  methods: {
    react() {
      //选择宠物子组件出现后重新加载
      this.reload();
    },
    getShowMsg(data) {
      //监听获得子组件slider传来的点击信息
      this.isShow = data.show;
      this.deviceCode = data.deviceCode;
 
    },
    listenIsShow(data) {
      //监听获得子组件choosePet传来的关闭信息值
      this.isShow = data;
    },
    isShowModel(val){
      //监听获得子组件header传来的打开自定义模态框的信息值
      this.isAdd = val;
    },
    cancelM(val){
      //关闭自定义模态框的信息值
      this.isAdd = val;
    }
  },
  beforeUpdate() {
    this.$nextTick(() => {
      this.Scroll = new IScroll(this.$refs.wrapper, {
        click: true
      });
    });
  },
  filters: {
    infosCmputed: function(value) {
      if (value == "TAG") return this.$t("prompt.QrCode");
    },
    lowercase: function(value) {
      return value.toLowerCase();
    }
  },
  components: {
    "v-header": header,
    "v-foot": footernav,
    "v-slider": slider,
    "v-choosePet": choosePet,
    adddeviceType
  }
};
</script>
<style scoped>
.hint {
  margin-top: 20px;
  text-align: center;
  height: 40px;
  line-height: 40px;
}
.notlogin {
  text-align: center;
  margin-top: 20px;
  font-size: 0.85rem;
}
.addDeviceBtn {
  text-align: center;
}
.addBtn {
  background-color: #085196;
  color: #fff;
  font-size: 1.3rem;

  width: 80%;
  display: block;
  margin: 0 auto;
  margin-top: 20px;
  border-radius: 50px;
}
.device_main {
  overflow: hidden;
  width: 100%;
  touch-action: none;
  /* position: absolute; */
  top: 200px;
  bottom: 0;
}
.device_main .addBtn {
  display: block;
  padding: 10px;
}
.home {
  width: 100%;
}
img {
  width: 100%;
}
.title {
  text-align: center;
  color: #828282;
  font-size: 0.8rem;
  margin-top: 1rem;
}

.device_content {
  /* margin-top: 25px; */
  padding: 10px;
}
.device_content .device_title,
.device_box {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  font-size: 0.85rem;
  padding: 5px 0;
  border-bottom: 1px solid #eee;
}
.device_content .device_code,
.device_box .device_code {
  flex: 6;
  color: #3f3f3f;
}
.device_content .bind_pet,
.device_box .bind_pet {
  flex: 18;
  padding-left: 10px;
}
.device_box {
  padding: 10px 0;
}
.device_box .bind_pet {
  border-left: 1px solid #eee;
  display: flex;
}
.device_code img {
  width: 1.5rem;
  display: block;
  margin: 0 auto;
}
.device_code span {
  display: block;
  margin-top: 5px;
  font-size: 0.5rem;
  text-align: center;
}
.bind_pet img {
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
}
.bind_pet span {
  padding-left: 20px;
  color: #808080;
  font-size: 1rem;
  line-height: 65px;
}
</style>



// WEBPACK FOOTER //
// src/m_page/home/home.vue